import { blue, blueGrey, grey, red } from '@mui/material/colors';

const white = '#FFFFFF';
const black = '#000000';

export default {
  third: {
    main: '#64DD17',
    contrastText: black,
  },
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#00236f',
    main: '#14499e',
    light: '#5674d0',
  },
  secondary: {
    contrastText: black,
    dark: '#007900',
    main: '#1faa00',
    light: '#62dd44',
  },
  success: {
    main: '#007900',
    contrastText: white,
  },
  successSecondary: {
    contrastText: '#228A2C',
    main: '#EBF8EC',
  },
  warning: {
    contrastText: '#CA8A04',
    main: '#FEFCE8',
  },
  error: {
    contrastText: white,
    dark: red[900],
    main: red[600],
    light: red[400],
  },
  errorSecondary: {
    contrastText: '#D32F2F',
    main: '#F5E2E2',
  },
  text: {
    contrastText: white,
    primary: grey[900],
    secondary: grey[900],
    tertiary: grey[500],
    caption: grey[700],
    icon: grey[300],
    link: blue[600],
  },
  link: blue[800],
  icon: blueGrey[600],
  background: {
    default: '#F4F6F8',
    paper: white,
  },
  divider: grey[200],

  mobile: {
    action: {
      grey: grey[100],
    },
    text: {
      secondary: grey[50],
    },
  },
  tableRows: {
    main: '#F6FBFF',
  },
  action: {
    hover: 'rgba(0, 0, 0, 0.01)',
    disabledBackground: '#A5B8D8',
  },
};
